import TvcPcComponent from "../../../../src/events/2023/03/tvcPc/main";
import * as React from 'react';
export default {
  TvcPcComponent,
  React
};